import { createReducer } from '@reduxjs/toolkit';

import { IAction } from '../../types/redux';

import {
  IStatsState,
  IUpdateAllCountersAction,
  IUpdateCounterAction,
  STATS_UPDATE_ALL_COUNTERS,
  STATS_UPDATE_COUNTER,
} from './stats.types';

const INITIAL_STATE: IStatsState = {
  isLoading: false,
  counters: {},
};

export const statsReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(STATS_UPDATE_COUNTER, (state: IStatsState, action: IAction<IUpdateCounterAction>) => {
      if (action.payload) {
        const { id, counter } = action.payload;
        state.counters[id] = counter;
      }
    })
    .addCase(
      STATS_UPDATE_ALL_COUNTERS,
      (state: IStatsState, action: IAction<IUpdateAllCountersAction>) => {
        if (!action.payload || !action.payload.dict) {
          return;
        }

        const { dict } = action.payload;
        state.counters = dict;
      },
    );
});
